export const baseUrl =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4500"
    : `${window.location.origin}`;
